/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cover_Letters_Select_ResumeInputs */

const en_cover_letters_select_resume = /** @type {(inputs: Cover_Letters_Select_ResumeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Select a resume...`)
};

const de_cover_letters_select_resume = /** @type {(inputs: Cover_Letters_Select_ResumeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lebenslauf auswählen...`)
};

const fr_cover_letters_select_resume = /** @type {(inputs: Cover_Letters_Select_ResumeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sélectionner un CV...`)
};

const es_cover_letters_select_resume = /** @type {(inputs: Cover_Letters_Select_ResumeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seleccionar un currículum...`)
};

const it_cover_letters_select_resume = /** @type {(inputs: Cover_Letters_Select_ResumeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seleziona un curriculum...`)
};

const nl_cover_letters_select_resume = /** @type {(inputs: Cover_Letters_Select_ResumeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Selecteer een CV...`)
};

const pl_cover_letters_select_resume = /** @type {(inputs: Cover_Letters_Select_ResumeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wybierz CV...`)
};

const fi_cover_letters_select_resume = /** @type {(inputs: Cover_Letters_Select_ResumeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Valitse ansioluettelo...`)
};

const da_cover_letters_select_resume = /** @type {(inputs: Cover_Letters_Select_ResumeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vælg et CV...`)
};

const sv_cover_letters_select_resume = /** @type {(inputs: Cover_Letters_Select_ResumeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Välj ett CV...`)
};

/**
* | output |
* | --- |
* | "Select a resume..." |
*
* @param {Cover_Letters_Select_ResumeInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const cover_letters_select_resume = /** @type {((inputs?: Cover_Letters_Select_ResumeInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cover_Letters_Select_ResumeInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_cover_letters_select_resume(inputs)
	if (locale === "fr") return fr_cover_letters_select_resume(inputs)
	if (locale === "es") return es_cover_letters_select_resume(inputs)
	if (locale === "it") return it_cover_letters_select_resume(inputs)
	if (locale === "nl") return nl_cover_letters_select_resume(inputs)
	if (locale === "pl") return pl_cover_letters_select_resume(inputs)
	if (locale === "fi") return fi_cover_letters_select_resume(inputs)
	if (locale === "da") return da_cover_letters_select_resume(inputs)
	if (locale === "sv") return sv_cover_letters_select_resume(inputs)
	return en_cover_letters_select_resume(inputs)
});